import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { nnrOrderService } from '@planning/services'
import { MRT_ColumnDef } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { PATHS } from 'modules/utils/src/utils/paths.utils'
import { ReleaseStatus } from '../../../models/ReleaseStatus'
import { useReleaseTableColumns } from '../../../tableConfigs/useReleaseTableColumns'
import { ReleaseTable } from '../../molecules/ReleaseTable'
import { ReleaseTableOptions } from '../../molecules/ReleaseTableOptions'

interface Props {
  items: INonNumericReleaseItem[]
}

export const NonNumericReleaseTable = observer(({ items }: Props) => {
  const { nonNumericReleaseColumns } = useReleaseTableColumns()

  return (
    <ReleaseTable
      items={items}
      columns={nonNumericReleaseColumns as MRT_ColumnDef<INonNumericReleaseItem>[]}
      initialFilterStatus={[ReleaseStatus.Open, ReleaseStatus.InProgress]}
      tableName='NonNumericReleasesTable'
      renderRowActions={({ row }) => {
        const releaseItem = row.original as INonNumericReleaseItem

        return (
          <ReleaseTableOptions
            id={releaseItem.id}
            canDelete={releaseItem.canDelete}
            canEdit={releaseItem.canEdit}
            onDelete={id => nnrOrderService.delete(id)}
            baseNavigationUrl={PATHS.orders.nonNumericReleases.url}
          />
        )
      }}
    />
  )
})
